var _path, _ellipse, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuincySideMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3569 9.04878L17.2309 12.1011C17.1975 12.1908 17.1375 12.2682 17.0589 12.3228C16.9803 12.3775 16.8868 12.4067 16.791 12.4067C16.6952 12.4067 16.6017 12.3775 16.5231 12.3228C16.4445 12.2682 16.3845 12.1908 16.3511 12.1011L15.2251 9.04877C15.2013 8.98438 15.1638 8.92588 15.1152 8.87733C15.0666 8.82877 15.0081 8.79137 14.9436 8.76756L11.888 7.64276C11.7982 7.60946 11.7207 7.54952 11.666 7.47097C11.6114 7.39242 11.582 7.29904 11.582 7.20336C11.582 7.10769 11.6114 7.01431 11.666 6.93575C11.7207 6.85721 11.7982 6.79727 11.888 6.76397L14.9436 5.63913C15.008 5.61538 15.0666 5.57795 15.1152 5.5294C15.1638 5.48085 15.2013 5.42234 15.2251 5.35792L16.3511 2.3056C16.3845 2.2159 16.4445 2.13854 16.5231 2.08391C16.6017 2.02929 16.6952 2.00001 16.791 2.00001C16.8868 2.00001 16.9802 2.02929 17.0589 2.08391C17.1375 2.13854 17.1975 2.2159 17.2309 2.3056L18.3569 5.35792C18.3807 5.42235 18.4182 5.48086 18.4668 5.5294C18.5154 5.57795 18.5739 5.61539 18.6384 5.63913L21.694 6.76398C21.7838 6.79728 21.8613 6.85722 21.916 6.93577C21.9707 7.01432 22 7.1077 22 7.20338C22 7.29905 21.9707 7.39243 21.916 7.47098C21.8613 7.54953 21.7838 7.60947 21.694 7.64277L18.6384 8.76757C18.5739 8.79138 18.5154 8.82878 18.4668 8.87733C18.4182 8.92589 18.3807 8.98438 18.3569 9.04878Z",
    stroke: "url(#paint0_linear_21999_1594)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.40975,
    cy: 3.15366,
    rx: 8.40975,
    ry: 3.15366,
    transform: "matrix(-0.70891 -0.705298 -0.70891 0.705298 18.7314 17.3281)",
    stroke: "#CECDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8279 13.5929C18.8279 18.2351 15.0609 21.9984 10.414 21.9984C5.76706 21.9984 2 18.2351 2 13.5929C2 8.95074 5.76706 5.1875 10.414 5.1875",
    stroke: "#CECDFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21999_1594",
    x1: 16.791,
    y1: 2.00001,
    x2: 16.791,
    y2: 12.4067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADABFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuincySideMenu);
export default __webpack_public_path__ + "static/media/icon-quincy-side-menu.817936426848902848854de33521c550.svg";
export { ForwardRef as ReactComponent };